import { MessagesPT } from "@/locale/locations/messages-pt";

enum Exceptions {
  NOT_FOUND_QUIZ = "NOT_FOUND_QUIZ",
  CSV_ERROR = "CSV_ERROR",
  INVALID_PARAMS = "INVALID_PARAMS",
  NOT_FOUND = "NOT_FOUND",
  TOKEN_INVALID = "TOKEN_INVALID",
  QUIZ_STATISTIC_ERROR = "QUIZ_STATISTIC_ERROR",
  QUESTION_NOT_FOUND = "QUESTION_NOT_FOUND",
  LEARNING_OBJECTIVE_NOT_FOUND = "LEARNING_OBJECTIVE_NOT_FOUND",
  UNDEFINED_ERROR = "UNDEFINED_ERROR",
  PERMISSION_DENIED = "PERMISSION_DENIED",
}

export { Exceptions, MessagesPT as Messages };
